import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  standalone: false,
  name: 'checkSideNavAuth',
})
export class CheckSideNavAuthPipe implements PipeTransform {
  transform(value: any, ...args: any[]): any {
    // return null;
    let isPrivilege = localStorage.getItem('hasPriviledge');
    if (localStorage.getItem('userType') == 'Bridge+') {
      return args[0];
    } else {
      if (isPrivilege) {
        return args[0];
      } else {
        console.log(args[0]);
        let newSideNav = [];
        let excludeNav = ['1', '2', '5', '6'];
        let counterIndex = -1;
        args[0].forEach((element) => {
          console.log(!excludeNav.includes(element.index));

          if (!excludeNav.includes(element.index)) {
            element.index = counterIndex + 1;
            newSideNav.push(element);
            counterIndex++;
          }
        });
        console.log(newSideNav);
        return newSideNav;
      }
    }
  }
}
